var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibleToiletPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5999 13.0436C22.9237 13.0436 23.9967 11.9705 23.9967 10.6468C23.9967 9.32309 22.9237 8.25 21.5999 8.25C20.2762 8.25 19.2031 9.32309 19.2031 10.6468C19.2031 11.9705 20.2762 13.0436 21.5999 13.0436Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.353 31.3465L34.982 32.1892L33.6336 25.8968C33.5512 25.52 33.3428 25.1825 33.0429 24.94C32.7429 24.6976 32.3693 24.5645 31.9836 24.5629H25.7465L25.2921 20.6254H33.0008V18.3754H25.0326L24.7419 15.8564C24.7165 15.6362 24.648 15.4233 24.5403 15.2296C24.4325 15.0359 24.2877 14.8654 24.1141 14.7277C23.9405 14.5899 23.7414 14.4878 23.5283 14.427C23.3152 14.3662 23.0922 14.348 22.8721 14.3734L20.0781 14.6958L21.4766 26.8129H31.5291L33.2699 34.9366L38.899 33.5293L38.353 31.3465Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 37.4997C19.7938 37.4994 17.8984 36.8194 16.3882 35.576C14.878 34.3326 13.8468 32.603 13.4709 30.6832C13.0951 28.7634 13.398 26.7727 14.3279 25.0516C15.2578 23.3305 16.7568 21.986 18.5685 21.248L18.3028 18.9453C14.096 20.3827 11.0625 24.3748 11.0625 29.0622C11.0625 34.9553 15.8569 39.7497 21.75 39.7497C23.5892 39.7488 25.397 39.2735 26.9988 38.3697C28.6005 37.4659 29.9421 36.1641 30.8937 34.5903L30.1875 31.3122C29.0625 34.6872 25.8703 37.4997 21.75 37.4997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibleToiletPoi);
export default __webpack_public_path__ + "static/media/accessible-toilet-poi.23dff26a72ba2b55f0622c4e120e847e.svg";
export { ForwardRef as ReactComponent };